
import { defineComponent } from "vue";
import { CellClass } from "@/types/pathFinders";

export default defineComponent({
    props: {
        cell: {
            type: CellClass,
            required: true,
        },
        cellSize: {
            type: Number,
            required: true,
        },
        isStartNode: {
            type: Boolean,
            required: true,
        },
        isEndNode: {
            type: Boolean,
            required: true,
        },
        isMouseDown: {
            type: Boolean,
            required: true,
        },
    },

    methods: {
        clickHandler() {
            if (this.isStartNode || this.isEndNode) return;

            this.$emit("clicked", this.cell.row, this.cell.col);
        },

        mouseOverHandler() {
            if (this.isStartNode || this.isEndNode) return;

            if (this.isMouseDown)
                this.$emit("clicked", this.cell.row, this.cell.col);
        },

        dragStarted() {
            this.$emit("nodeDragStart", this.cell);
            return false;
        },

        dropOverCell(event: Event) {
            event.preventDefault();

            this.$emit(`nodeDropped`, this.cell);
        },
    },
});
